import { render, staticRenderFns } from "./AddSection.vue?vue&type=template&id=275da926&scoped=true&v-on-clickaway=cancel&"
import script from "./AddSection.vue?vue&type=script&lang=ts&"
export * from "./AddSection.vue?vue&type=script&lang=ts&"
import style0 from "./AddSection.vue?vue&type=style&index=0&id=275da926&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275da926",
  null
  
)

export default component.exports